__turbopack_context__.v({
  "cameraButton": "styles-module__6Lq8UG__cameraButton",
});
